const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingcom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#0c3b7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.69 16.14H8.48v-2.65c0-.56.22-.85.71-.92h1.5a1.65 1.65 0 0 1 1.77 1.77 1.64 1.64 0 0 1-1.77 1.8zM8.48 9v-.68c0-.61.26-.9.83-.94h1.13A1.42 1.42 0 0 1 12 8.93a1.48 1.48 0 0 1-1.52 1.61h-2zm5 2.64-.4-.23.35-.29a3.23 3.23 0 0 0 1.08-2.49c0-2.07-1.61-3.41-4.09-3.41H7.29A1.39 1.39 0 0 0 6 6.6v11.76h4.55c2.77 0 4.55-1.51 4.55-3.84a3.19 3.19 0 0 0-1.54-2.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 16.73a1.62 1.62 0 1 1 1.62 1.63 1.62 1.62 0 0 1-1.62-1.63",
    style: {
      fill: "#00bafc"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingcom);
export default __webpack_public_path__ + "static/media/Bookingcom.dfbce46afc779638d2f6fab2afea9ce2.svg";
export { ForwardRef as ReactComponent };